document.addEventListener("turbo:load", () => {
  const comment = document.querySelector(".highlighted-comment");
  if (comment) {
    const top = comment.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }
});
